app.service('basketAccessories', function (html, broker, pageConfig, orderConfig, basketAnalytics,
	basketAccessorySearch, productDetailsModal, simpleToastr, carouselSlider) {
	var $self, $tabsContent, $tabsNav;
	var config, $ajax;
	let activeTab = false;
	let activeTabProductIds = '';

	function isAccessoryAlreadyAdded(productId) {
		const basketData = pageConfig.getData('basket');
		const alreadyAdded = basketData.items.filter(function (e) {
			return e.id == productId;
		});
		return alreadyAdded.length > 0;
	}

	function loadTabContent(tabId, productIds) {
		let url = '';
		if (tabId === 'recommended') {
			url = '/web-cached/cart-recommended-accessories.ltr';
		} else {
			url = '/web-cached/cart-accessories.ltr';
		}
		const data = {
			'productIds': productIds
		};
		if ($ajax) {
			$ajax.abort();
		}
		$tabsContent.addClass('loading');
		$ajax = $.ajax({
			url: url,
			method: 'GET',
			data: data,
			success: function (html) {
				$tabsContent.removeClass('loading');
				$tabsContent.html(html);
				const $tabsContentActiveSlider = $tabsContent.find('.group-content.is-active .carousel-slider')
				if ($tabsContentActiveSlider.length) {
					carouselSlider.init($tabsContentActiveSlider);
				}
			},
			error: function () {
				$tabsContent.removeClass('loading');
				$tabsContent.html('<p class="error">Nie można wczytać tej kategorii akcesoriów. Prosimy spróbować ponownie później.</p>');
			}
		});
	}
	function selectAccessoriesGroup(groupId) {
		const $groupContent = $tabsContent.find(`.group-content[data-group="${groupId}"]`);
		$groupContent.addClass('is-active').siblings().removeClass('is-active');
		$tabsContent.removeClass('loading');
		carouselSlider.init($groupContent.find('.carousel-slider'));
	}

	function setElements() {
		$self = $('#basket-accessories');
		$tabsNav = $('.basket-accessories-nav', $self);
		$tabsNavButton = $('.js-accessories-main-tab', $self);
		$tabsContent = $('#basket-accessories-tab-content', $self);
	}
	function setEvents() {
		$tabsNavButton.on('click', function () {
			clickMainTab($(this).data('tab-id'));
		});
		$('.js-accessory-search', $self).on('click', function () {
			basketAccessorySearch.open(activeTab);
		})
		$self.on('click', '.js-group-switch', function () {
			const groupId = $(this).data('group');
			const $parentTab = $(this).closest('.tab-content');
			$(this).addClass('is-active').siblings().removeClass('is-active');
			selectAccessoriesGroup(groupId);
		}).on('click', '.js-accessory-details', function () {
			const $accessoryItem = $(this);
			const productName = $accessoryItem.find('.accessory-description').text().trim();
			const accessoryId = $accessoryItem.data('accessory-id');
			const accessoryPlu = $accessoryItem.data('accessory-plu');
			productDetailsModal.open({
				productId: accessoryId,
				productPlu: $accessoryItem.data('accessory-plu'),
				parentId: $accessoryItem.data('parent-id'),
				productDetailsModalOpen: function () {
					productDetailsModal.setAddToCartButton({ isAdded: isAccessoryAlreadyAdded(accessoryId) });
				},
				callbackAdded: function () {
					basketAnalytics.addProduct(accessoryPlu, 'accessory_card');
					simpleToastr.afterReloadMessage(`<h2>Produkt dodany do koszyka</h2><p>${productName}</p>`);
					broker.trigger('REFRESH_BASKET_VIEW');
				}
			});
			UA.interaction('Koszyk - K1', 'Warstwa ze szczegółami akcesorium', 'Kliknięcie');
		});
		carouselSlider.init($tabsNav); // inicjalizacja slidera dla górnej belki nawigacyjnej
	}
	function clickMainTab(tabId, force) {	// force jest używy po przeładowaniu koszyka aby wymusić ponowne zaczytanie
		if (activeTab != tabId || force) {
			activeTab = tabId;
			$tabsNavButton.removeClass('active');
			let $currentTabNavButton = $tabsNavButton.filter(`[data-tab-id="${tabId}"]`);
			if (!$currentTabNavButton.length) {
				$currentTabNavButton = $tabsNavButton.first();
				activeTab = $currentTabNavButton.data('tab-id');
			}
			activeTabProductIds = $currentTabNavButton.data('product-ids');
			$currentTabNavButton.addClass('active');
			loadTabContent(activeTab, activeTabProductIds);
		}
	}
	function init() {
		config = orderConfig.getData();
		if (!config.deliveryMode && html.has('new-accessories')) {	// jeśli nie ma trybu dostawy to nie wczytujemy akcesoriów
			setElements();
			if ($self.length) {
				basketAccessorySearch.init();
				setEvents();
				clickMainTab(activeTab ? activeTab : 'recommended', true);	// po przeładowaniu koszyka otwieramy wcześniejszą kategorię, ewentualnie rekomendowaną, jeśli żadna się nie znajdzie to pierwsza
			}
		}
	}

	return {
		init
	};
});
